module.exports = __webpack_public_path__ + "static/img/dormido.baf4359.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buttons/dormido.png
// module id = 216
// module chunks = 1